import { useEffect, useRef } from 'react';

// Shared observer instance and tracking of intersected elements
let observer = null;
const elementsMap = new Map();
const createObserver = () => {
  if (observer) return observer;
  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const callback = elementsMap.get(entry.target);
        if (callback) {
          callback();
          elementsMap.delete(entry.target);
          observer.unobserve(entry.target);
        }
      }
    });
  });
  return observer;
};
export const useIntersectionObserver = ({
  onIntersect,
  targetRef
}) => {
  // Store the latest onIntersect in a ref to avoid effect re-running on every render
  const latestOnIntersect = useRef(onIntersect);
  latestOnIntersect.current = onIntersect;
  useEffect(() => {
    const isIntersectionObserverAvailable = typeof window !== 'undefined' && 'IntersectionObserver' in window;
    const currentRef = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
    if (!isIntersectionObserverAvailable || !currentRef) {
      return;
    }
    const obs = createObserver();
    elementsMap.set(currentRef, () => latestOnIntersect.current());
    obs.observe(currentRef);
    return () => {
      if (currentRef) {
        elementsMap.delete(currentRef);
        obs.unobserve(currentRef);
        if (elementsMap.size === 0) {
          obs.disconnect();
          observer = null;
        }
      }
    };
  }, [targetRef]);
};